import { render, staticRenderFns } from "./CargoShipping.vue?vue&type=template&id=33e6d96d&scoped=true&"
import script from "./CargoShipping.vue?vue&type=script&lang=js&"
export * from "./CargoShipping.vue?vue&type=script&lang=js&"
import style0 from "./CargoShipping.vue?vue&type=style&index=0&id=33e6d96d&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e6d96d",
  null
  
)

export default component.exports